import { useSelector } from 'react-redux'

import { getRespondent } from 'ducks/respondent'
import { getLocation } from 'ducks/router'
import { usePuppeteerGoto } from 'hooks'
import { t } from 'ttag'

import {
  skillTraitMapping,
  getExplanations,
} from 'components/modals/TestsReportModal/tabs/Competency/model'
import {
  getVisibleCategory,
  getCategoryKeys,
} from 'components/modals/TestsReportModal/tabs/helpers'

export const useReport = () => {
  const {
    payload: { language, uuid },
  } = useSelector(getLocation)

  const respondent = useSelector(getRespondent)

  const { name = '', scores = null, project, stats = {}, id } = respondent

  usePuppeteerGoto()

  if (!project || !scores) {
    return { state: {}, handlers: {} }
  }

  const categoryKeys = project
    ? getCategoryKeys(project.profile.categories)
    : null

  const explanations = categoryKeys
    ? getExplanations(categoryKeys, language)
    : null

  const visibleCategories = {
    id: id,
    scores: getVisibleCategory(categoryKeys, scores, language),
  }

  const getTraitScores = selectedCompetency => [
    {
      id: id,
      name: name,
      scores: skillTraitMapping[categoryKeys[selectedCompetency]]?.map(
        trait => ({
          score: scores[trait],
          label: trait,
        }),
      ),
    },
  ]

  const getScoreLabel = selectedCompetency => {
    const scoreToLabel = {
      0: t`Low`,
      1: t`Low`,
      2: t`Normal`,
      3: t`High`,
      4: t`High`,
    }

    return scoreToLabel[visibleCategories.scores[selectedCompetency]['score']]
  }

  const radarData = visibleCategories.scores

  return {
    state: {
      language,
      name,
      scores,
      stats,
      visibleCategories,
      explanations,
      project,
      radarData,
      respondent,
    },
    handlers: { getTraitScores, getScoreLabel },
  }
}
